// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1c40cb1d","732":"2d85f2a2","977":"880e7172"}[chunkId] + ".chunk.js";
};